import React from 'react';
import I18n from '@/modules/i18n';

interface GenericLibraryIconProps {
  ariaLabel?: string;
  color?: string;
  size?: number;
}

// AIDEV-NOTE: fallback icon for libraries with no dedicated one. Content can add a library without a
// code change (PLAT-14851), so every library-icon lookup needs this default.
// Source: TCI Design System, "Reference Libraries icons" / bio (node 2306-1489). The paths keep their
// original design-system coordinates; the translate maps that 30x30 symbol onto the viewBox origin.
// This icon will eventually be swapped to be the new BiographiesIcon.
const GenericLibraryIcon = ({
  ariaLabel = I18n.t('library'),
  color = '#247F99',
  size = 60,
}: GenericLibraryIconProps) => (
  <svg
    aria-label={ariaLabel}
    fill="none"
    height={size}
    viewBox="0 0 30 30"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-44.9998, -32.9998)">
      <path
        d="M68.9338 34.3762C70.0037 34.3764 70.8713 35.2438 70.8713 36.3137V56.9387C70.8712 58.0086 70.0037
           58.876 68.9338 58.8762H55.7463V60.3762C55.7462 61.0664 55.1865 61.626 54.4963 61.6262C53.8061
           61.6262 53.2464 61.0665 53.2463 60.3762V58.8762H53.1213C50.9122 58.8762 49.1214 57.0853 49.1213
           54.8762V45.2512C49.1214 44.5609 49.681 44.0012 50.3713 44.0012C51.0615 44.0014 51.6213 44.561
           51.6213 45.2512V51.1682C52.0846 50.9807 52.5908 50.8762 53.1213 50.8762H68.3713V36.8762H53.1213C52.2929
           36.8762 51.6214 37.5478 51.6213 38.3762V39.7512C51.6212 40.4414 51.0615 41.001 50.3713 41.0012C49.681
           41.0012 49.1214 40.4415 49.1213 39.7512V38.3762C49.1214 36.1671 50.9122 34.3762 53.1213
           34.3762H68.9338ZM53.1213 53.3762C52.293 53.3762 51.6214 54.0479 51.6213 54.8762C51.6214 55.7046
           52.293 56.3762 53.1213 56.3762H53.2463V54.8762H55.7463V56.3762H68.3713V53.3762H53.1213Z"
        fill={color}
      />
      <path
        d="M60.3055 43.8412C61.4325 43.8412 62.3461 42.9733 62.3461 41.9027C62.3461 40.832 61.4325 39.9641
           60.3055 39.9641C59.1785 39.9641 58.2649 40.832 58.2649 41.9027C58.2649 42.9733 59.1785 43.8412
           60.3055 43.8412Z"
        fill={color}
      />
      <path
        d="M57.2446 47.7184C57.2446 46.1124 58.615 44.8105 60.3055 44.8105C61.996 44.8105 63.3664 46.1124
           63.3664 47.7184V48.203C63.3664 48.4707 63.138 48.6876 62.8563 48.6876H57.7548C57.473 48.6876
           57.2446 48.4707 57.2446 48.203V47.7184Z"
        fill={color}
      />
    </g>
  </svg>
);

export default GenericLibraryIcon;
